export default "__VITE_ASSET__B9MZT_fh__"